var optionsDefaults = {
	speed: 700,
	transition: 'fade',
	opacity: .90,
	scalePhotos: true,
	// closeButton: false,
	maxWidth: '90%',
	maxHeight: '90%',
	initialWidth: 500,
	initialHeight: 300,
	fixed: true,
	current: ''
}